import React from 'react'
// import { Route, Routes } from "react-router";
// import {BrowserRouter as Router} from 'react-router-dom'
import { BrowserRouter as Router, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { controllers } from '../Controllers/Controllers';
// import { controllers } from '../Controllers/Controllers'
import { navigator } from '../Controllers/Navigator'
import Core from './Core'
import { IncludeFooterView } from '../Views/Components/IncludeFooterView';
import { UnsubscribeView } from '../Views/Core/UnsubscribeView';
import { NotFoundView } from '../Views/Core/NotFoundView';
import { OutreachPage } from '../Views/Pages/Outreach/OutreachView';
import { CategoriesPage } from '../Views/Pages/Outreach/Categories/CategoriesView';
import { ResearchPage } from '../Views/Pages/Outreach/Research/ResearchView';
import { ReportPage } from '../Views/Pages/Outreach/Report/ReportView';
import { RequestsPage } from '../Views/Pages/Outreach/Requests/RequestsView';
import { LeadFormPage } from '../Views/Pages/Outreach/LeadForm/LeadFormView';
import { MailPage } from '../Views/Pages/Outreach/Mail/MailView';
import { ComposePage } from '../Views/Pages/Outreach/Compose/ComposeView';
import { ComposeCampaignPage } from '../Views/Pages/Outreach/ComposeCampaign/ComposeCampaignView';
import { CommunicationsPage } from '../Views/Pages/Outreach/Communications/CommunicationsView';
import { TemplatesPage } from '../Views/Pages/Outreach/Templates/TemplatesView';
import { TemplateFormPage } from '../Views/Pages/Outreach/TemplateForm/TemplateFormView';
import { SettingsPage } from '../Views/Pages/Settings/SettingsView';
import { ActivityDashboardPage } from '../Views/Pages/Dashboard/AdminDashboard';
import { RightSeparator } from '../Views/Pages/RightSeparator/RightSeparator';
import { MyEmailStatsPage } from '../Views/Pages/Dashboard/MyStats';
import { MyDashboardPage } from '../Views/Pages/Dashboard/MyDashboardPage';
import { WorkerCompensationSetupPage } from '../Views/Pages/Compensations/WorkerCompensationSetupPage';
import { IssueCompensationPage } from '../Views/Pages/Compensations/IssueCompensationPage';
import { MyCompensationsPage } from '../Views/Pages/Compensations/MyCompensationsPage';
import { InvoiceTemplateEditorPage } from '../Views/Pages/Compensations/InvoiceTemplateEditorPage';
// import ChatInterface from '../Views/ContentView/Chat/SomeHowChat';

class MainNavigation extends React.Component {

    render(){
        const { home } = controllers().page
        return <Router>
            <NavigatorComponent/>
            <Core>
                <Routes>
                    <Route path="/unsubscribe" element={<UnsubscribeView/>} />
                    <Route path="/outreach" element={<OutreachPage/>} />
                    <Route path="/outreach/categories" element={<CategoriesPage/>} />
                    <Route path="/outreach/research" element={<ResearchPage/>} />
                    <Route path="/outreach/report" element={<ReportPage/>} />
                    <Route path="/outreach/requests" element={<RequestsPage/>} />
                    <Route path="/outreach/add" element={<LeadFormPage/>} />
                    <Route path="/outreach/:id/edit" element={<LeadEditWrapper/>} />
                    <Route path="/outreach/inbox" element={<MailPage folder="inbox"/>} />
                    <Route path="/outreach/sent" element={<MailPage folder="sent"/>} />
                    <Route path="/outreach/compose" element={<ComposePage/>} />
                    <Route path="/outreach/compose/:leadId" element={<ComposeLeadWrapper/>} />
                    <Route path="/outreach/compose/campaign" element={<ComposeCampaignPage/>} />
                    <Route path="/outreach/communications/:leadId" element={<CommunicationsLeadWrapper/>} />
                    <Route path="/outreach/communications" element={<CommunicationsPage/>} />
                    <Route path="/outreach/templates" element={<TemplatesPage/>} />
                    <Route path="/outreach/templates/add" element={<TemplateFormPage/>} />
                    <Route path="/outreach/templates/:templateId/edit" element={<TemplateEditWrapper/>} />
                    <Route path="/payroll" element={<RightSeparator AdminComponent={<PayrollSetupWrapper/>} UserComponent={<MyCompensationsPage/>}/>} />
                    <Route path="/payroll/templates" element={<InvoiceTemplateEditorPage/>} />
                    <Route path="/payroll/issue" element={<IssueCompensationWrapper/>} />
                    <Route path="/payroll/issue/:workerId" element={<IssueCompensationWrapper/>} />
                    <Route path="/activity" element={<RightSeparator AdminComponent={<ActivityDashboardPage/>} UserComponent={<MyDashboardPage/>}/>} />
                    <Route path="/dashboard" element={<MyDashboardPage/>} />
                    <Route path="/settings" element={<SettingsPage/>} />
                    <Route path="/" element={<OutreachPage/>} />
                    <Route path="*" element={<IncludeFooterView><NotFoundView/></IncludeFooterView>} />
                </Routes>
            </Core>
        </Router>
    }
}

export { MainNavigation }

function NavigatorComponent() {
    const navigate = useNavigate();
    navigator().initNavigation(navigate)
    return <div className='navigator'></div>
}

function LeadEditWrapper() {
    const { id } = useParams();
    return <LeadFormPage leadId={id} />;
}

function ComposeLeadWrapper() {
    const { leadId } = useParams();
    return <ComposePage leadId={leadId} />;
}

function CommunicationsLeadWrapper() {
    const { leadId } = useParams();
    return <CommunicationsPage leadId={leadId} />;
}

function TemplateEditWrapper() {
    const { templateId } = useParams();
    return <TemplateFormPage templateId={templateId} />;
}

function PayrollSetupWrapper() {
    const navigate = useNavigate();
    return (
        <WorkerCompensationSetupPage
            onIssueCompensation={(workerId) => navigate(`/payroll/issue/${workerId}`)}
        />
    );
}

function IssueCompensationWrapper() {
    const { workerId } = useParams();
    const navigate = useNavigate();
    return (
        <IssueCompensationPage
            workerId={workerId ? Number(workerId) : undefined}
            onDone={() => navigate('/payroll')}
        />
    );
}